import { ResetPasswordInput, ResetPasswordOutput } from '@allocab/allocab-commons-shared-types';
// eslint-disable-next-line import/named
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { driverApi } from '../services/network/Api';

const resetPassword = (input: ResetPasswordInput) =>
  driverApi.post<ResetPasswordInput, ResetPasswordOutput>('/authentication/v1/user/reset-password', input, {
    skipAuth: true,
  });

export const useResetPassword = (options: UseMutationOptions<ResetPasswordOutput, unknown, ResetPasswordInput> = {}) =>
  useMutation<ResetPasswordOutput, unknown, ResetPasswordInput>({
    mutationFn: resetPassword,
    ...options,
  });
